import { render, staticRenderFns } from "./RateCards.vue?vue&type=template&id=83960f0c&"
import script from "./RateCards.vue?vue&type=script&lang=js&"
export * from "./RateCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports